import { C } from '../../shared/design-tokens.js';

export const TERMINAL_COLORS: Record<string, string> = {
  home: 'rgba(255,255,255,0.03)',
  5161: 'rgba(29,53,87,0.42)',
  1531: 'rgba(201,162,39,0.18)',
  1421: 'rgba(78,205,196,0.16)',
  5741: 'rgba(255,107,107,0.14)',
};

export const TERMINAL_ABBREV: Record<string, string> = {
  Alexandria: 'AEX',
  Lafayette: 'LFT',
  Monroe: 'MLU',
  Shreveport: 'SHV',
};

interface GridDay {
  status?: string;
  type?: string;
  terminal?: {
    name?: string;
    number?: string;
    code?: string;
  };
}

interface DriverConstraint {
  constraint_type: string;
  day_of_week?: number;
}

interface DriverWithConstraints {
  constraints?: DriverConstraint[];
}

export function dayStatusPresentation(day: GridDay | null | undefined) {
  if (day?.status === 'day_override') {
    return {
      label: 'OFF',
      background: 'rgba(255,107,107,0.12)',
      color: C.red,
    };
  }

  if (day?.status === 'terminal' && day?.terminal) {
    const terminalLabel = day.terminal.code
      || TERMINAL_ABBREV[day.terminal.name || '']
      || String(day.terminal.name || 'TER').slice(0, 3).toUpperCase();
    return {
      label: terminalLabel,
      background: TERMINAL_COLORS[day.terminal.number || ''] || 'rgba(255,255,255,0.03)',
      color: '#fff',
    };
  }

  if (day?.status === 'home') {
    return { label: 'HOME', background: 'transparent', color: C.textMuted };
  }

  if (day?.status === 'off_rotation') {
    return { label: 'OFF', background: 'transparent', color: C.textMuted };
  }

  if (day?.status === 'time_off') {
    return {
      label: String(day.type || 'OFF').toUpperCase().slice(0, 3),
      background: 'rgba(255,107,107,0.1)',
      color: C.red,
    };
  }

  return { label: '-', background: 'transparent', color: C.textMuted };
}

export function hasConstraintViolation(driver: DriverWithConstraints | null | undefined, isoDay: string, day: GridDay | null | undefined): boolean {
  if (!driver || day?.status !== 'terminal') return false;
  const dayOfWeek = new Date(`${isoDay}T00:00:00Z`).getUTCDay();
  return (driver.constraints || []).some((constraint) => {
    if (constraint.constraint_type === 'no_day' && constraint.day_of_week === dayOfWeek) return true;
    if (constraint.constraint_type === 'no_weekends' && (dayOfWeek === 0 || dayOfWeek === 6)) return true;
    return false;
  });
}
